module.exports = __webpack_public_path__ + "img/trip-icon_caracteristicas-personalidad.a00857d6.svg";